import {
  REMOVE_SUBSCRIBED_GROUP_CHAT
} from '../action_types'

export default (uid, key, scope) => {
  return {type: REMOVE_SUBSCRIBED_GROUP_CHAT, uid, key, scope}
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/actions/remove_subscribed_group.js
 **/